import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';

export const getAutosaveSettings = (settings?: IAdminSetting[]) => {
  const enable = settings?.find(st => st.code === AdminSettingCodesEnum.PASSPORT_AUTOSAVE);
  const mins = settings?.find(st => st.code === AdminSettingCodesEnum.PASSPORT_AUTOSAVE_PERIOD_MINUTES);

  return {
    enable: enable?.value === 'true',
    mins: mins?.value ? parseInt(mins?.value, 10) : 0,
  };
};
